"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGE_ASSIGNMENTS = 'MESSAGE_ASSIGNMENTS';
function onMessage(topicName) {
    return function (target, propertyKey) {
        if (!target[exports.MESSAGE_ASSIGNMENTS]) {
            target[exports.MESSAGE_ASSIGNMENTS] = {};
        }
        target[exports.MESSAGE_ASSIGNMENTS][topicName] = propertyKey;
    };
}
exports.onMessage = onMessage;
//# sourceMappingURL=on-message.js.map